/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2024 ICEMEDX, Inc.
***********************************************/
import { IceEntity } from '../../core/IceEntity';

export class benefitscoordination extends IceEntity {
  benefits_coordination_key: string = "";
  payer_name: string = "";
  effective_date: any = NaN;
  expiration_date: any = NaN;
  consent: string = "";
  pbm_member_id: string = "";
  cardholderid: string = "";
  cardholderlastname: string = "";
  cardholderfirstname: string = "";
  cardholdermiddlename: string = "";
  cardholdersuffix: string = "";
  cardholderprefix: string = "";
  groupid: string = "";

  gettablename(): string {
    return "BENEFITS_COORDINATION";
  }

  hassubtree(ColumnName): boolean {
    if (ColumnName.Length == 0) return false;
    else if (ColumnName == "IDS") return true;

    return false;
  }

  getsubtreetablename(ColumnName): string {
    if (ColumnName.Length == 0) return null;
    else if (ColumnName == "IDS") return "IDENTIFICATION";

    return null;
  }
}
